/**
 * Мінімум результату пошуку, за яким шукаємо повтори (повний тип —
 * `ISearchResult` у `Search.tsx`).
 */
interface SearchHitLike {
    resource: string
    id: number
}

/**
 * Видача без повторів запису.
 *
 * Ядровий індекс PostgreSQL тримає унікальність `(resource, entity_id, locale)`,
 * а `locale` у нелокалізованих ресурсів — `NULL`, і PostgreSQL вважає `NULL`
 * різними: кожна переіндексація запису додає ще один рядок, і клієнт приходив
 * у видачі двічі-тричі. Корінь — у схемі таблиці ядра; тут лише прибираємо
 * повтори, зберігаючи порядок релевантності.
 */
export const uniqueSearchResults = <T extends SearchHitLike>(results: T[]): T[] => {
    const seen = new Set<string>()

    return results.filter((result) => {
        const key = `${result.resource}:${result.id}`

        if (seen.has(key)) return false

        seen.add(key)

        return true
    })
}
